<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="color"
  >
    <mask id="org-root-mask" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#org-root-mask)">
      <path d="M4.49985 16.7105V2.5H15.5525V16.7105H11.6726V12.8846H8.37973V16.7105H4.49985ZM7.62974 10.3127H9.09688V8.8659H7.62974V10.3127ZM7.62974 7.03316H9.09688V5.5864H7.62974V7.03316ZM10.9554 10.3127H12.4226V8.8659H10.9554V10.3127ZM10.9554 7.03316H12.4226V5.5864H10.9554V7.03316Z" fill="currentColor" />
      <path d="M2.9209 17.5V15.9211H17.1314V17.5H2.9209Z" fill="currentColor" />
    </g>
  </svg>
 </template>

 <script>
 export default {
   name: 'org-root-icon',
   props: {
     width: { type: [String, Number], default: 20 },
     height: { type: [String, Number], default: 20 },
     color: { type: String, default: 'text-[#4D5159]' },
   },
 };
 </script>


